<header>		
    <div class="header_main_sec">
        <div class="container">
            <div class="head_logo">
                <a routerLink="/projects">  <h2><img src="assets/images/logo_head.png"></h2></a>
            </div>
			
            <div class="page_menu"> 
                <div class="full_screen_menu">
					<div class="collapse-bar" (click)="clickEvent()"><i class="fa fa-bars" aria-hidden="true"></i></div>
                    <div class="header_btn_sect"> 

                        <div class="user"> 
                            <a *ngIf="session_data.role == 1" class="add_btn btn" routerLink="/projects/add"><img class="img-add" alt="user"  src="assets/images/plus.png">ADD PROJECT</a>
                            <a (click)="reload_if_same($event)" [routerLinkActive]="['active']" routerLink="/change-password"  class="lg-call"><span>{{session_data.name}}</span></a>
                            <span role="button" title="Logout" (click)="doLogout()"><img alt="user"  src="assets/images/logout.png"></span>
                        </div>
                    </div>
                    <div class="res_menu"> 
                        <div id="hamburger" class="hamburger-icon-container">
                            <span style="font-size:30px;cursor:pointer" onclick="openNav()">&#9776;</span>
                        </div>
                    </div>
                    <div class="hd_menu">
                        <h3>Projects</h3>

                    </div>	

                </div>

            </div>

        </div>
    </div>
</header>


<div class="sidebar sidenav" id="mySidenav">
    <a href="javascript:void(0)" class="closebtn" onclick="closeNav()">&times;</a>
    <div class="sidenav1 pt-25">
        <div class="hd_menu_side">
            <ul class="" id="">
                <li class="side_top_pro" *ngFor="let project of projects; let i = index">
                    <!--<a routerLink="/dashboard" queryParams="{ id : 'hai' }" queryParamsHandling="merge">{{project.name}}</a>-->
                    <!--<a [routerLink]="['/dashboard']" [queryParams]="{ id: project.id }">{{project.name}}</a>-->
                    <a [routerLink]="['/dashboard']" [queryParams]="{ id: project.id }">
					<span class="nav-icon"><img class="img-add" alt="file"  src="assets/images/file.png"></span>
					<h6>{{project.name}}</h6><p><img class="img-add" alt="user"  src="assets/images/d-right.png"></p></a>
                </li>
            </ul> 
        </div>
    </div>
</div>

